export enum ApplicableViewEnum {
  COUPON_CODE,
  FORM_DETAILS,
  PAYMENT_DETAILS,
  CONFIRMATION
}
